import React from 'react'
import "./About_why_choose_us_card.css"

function About_why_choose_us_card({ text1, text2, imgSrc, description }) {
    return (
        <>
            <section className='About_why_choose_us_card'>
                <div className='outer_content_holder'>
                    <div className="text_holder">
                        <h4>{text1} <br /> {text2}</h4>
                    </div>

                    <div className="img_holder">
                        <img className="logo_img"
                            src={
                                process.env.PUBLIC_URL +
                                imgSrc
                            }
                            alt="logo"
                        />
                    </div>

                    <div className='discription_holder'>
                        <p>{description}</p>
                    </div>
                </div>
            </section>
        </>
    )
}

export default About_why_choose_us_card